import { useApp } from '../store/app.js';
import { Icon } from './Icon.js';

export function Toasts() {
  const { toasts, dismissToast } = useApp();
  if (toasts.length === 0) return null;

  return (
    <div aria-live="polite">
      {toasts.slice(-2).map((toast) => (
        <div key={toast.id} className="toast glass" role="status">
          <span className="grow">{toast.message}</span>
          {toast.action && (
            <button
              className="inline-target"
              style={{ fontWeight: 620, color: 'var(--accent)' }}
              onClick={() => { toast.action!.run(); dismissToast(toast.id); }}
            >
              {toast.action.label}
            </button>
          )}
          <button className="inline-target subtle" onClick={() => dismissToast(toast.id)} aria-label="סגירה">
            <Icon name="close" size={16} />
          </button>
        </div>
      ))}
    </div>
  );
}
